export const supportedLngs = ['pl', 'en'] as const;

export type LangCode = (typeof supportedLngs)[number];

export const fallbackLng: LangCode = 'pl';

export const defaultNS = 'common';

export const languageStorageKey = 'i18nextLng';

export type LangOption = {
  value: LangCode;
  label: string;
  ogLocale: string;
  htmlLang: string;
};

export const allLangs: LangOption[] = [
  { value: 'pl', htmlLang: 'pl', label: 'Polski', ogLocale: 'pl_PL' },
  { value: 'en', htmlLang: 'en', label: 'English', ogLocale: 'en_GB' },
];

export function getCurrentLang(lang?: string): LangOption {
  const fallbackOption = allLangs.find((item) => item.value === fallbackLng) ?? allLangs[0];

  if (!lang) {
    return fallbackOption;
  }

  return allLangs.find((item) => item.value === lang) ?? fallbackOption;
}
